import { Component, OnInit } from '@angular/core';
import { GlobalsService } from '../../shared/services/globals.service';

@Component({
  selector: 'cp-time-off-cal',
  templateUrl: './time-off-cal.component.html',
  styleUrls: ['./time-off-cal.component.scss']
})
export class TimeOffCalComponent implements OnInit {

  constructor(private svc_globals: GlobalsService) { }

  ngOnInit() {
  }
  calendar: string = "https://www.fieldgetics.com/EmployeeTime/index.html?personId=" + this.svc_globals.personId;
}